export default __webpack_public_path__ + "static/media/daCrazyBlackMode.a0c78c7b.svg";